import React, { useContext } from "react";
import Store from "nexia_mobile/flux_like/store";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

const styles = {
  container: {
    height: "2em",
    backgroundColor: "rgba(0,0,0,0.5)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    color: "white",
  },
};

const PivotDemoBanner = () => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.PivotDemoBanner;
  const inDemoMode = Store.appState && Store.appState.inDemoMode;
  return inDemoMode ? (
    <div style={styles.container}>
      <span style={styles.text}>{language.saveDoesNotOccur}</span>
    </div>
  ) : null;
};

export default PivotDemoBanner;



// WEBPACK FOOTER //
// ./src/components/Commercial/PivotDemoBanner.jsx